export const WpnInOut = () => import("./wpn-in-out.vue");
export const WpnOut = () => import("./wpn-out.vue");
export const WpnIn = () => import("./wpn-in.vue");
export const WpnDaily = () => import("./wpn-daily.vue");
export const WpnDateRange = () => import("./wpn_date_range.vue");
export const KoteMGT = () => import("./index.vue");
export const UserDetails = () => import("./user_details.vue");
export const List = () => import("./List.vue");
export const WpnUsers = () => import("./WpnUsers.vue");
export const WpmTypes = () => import("./wpm_types.vue");
export const WpmTypeUsers = () => import("./wpn_type_users.vue");
export const UserWpns = () => import("./UserWpns.vue");
